import data from "../../../../../src/UnderlineNav2/UnderlineNav2.docs.json";
import * as React from 'react';
export default {
  data,
  React
};